import * as React from "react"
import PropTypes from "prop-types"
import HeroSectionWrapper from "components/Hero/HeroSectionWrapper"
import HeroWrapper from "components/Hero/HeroWrapper"
import HeroContainer from "components/Hero/HeroContainer"
import Breadcrumbs from "components/Breadcrumbs"
import HeroBreadcrumbsLink from "components/Hero/HeroBreadcrumbsLink"
import HeroCaseText from "components/HeroCase/HeroCaseText"
import HeroTextBeforeTitle from "components/Hero/HeroTextBeforeTitle"
import HeroCaseTitle from "components/HeroCase/HeroCaseTitle"

import HeroImageContainer from "components/Hero/HeroImageContainer"
import HeroBackgroundImage from "components/Hero/HeroBackgroundImage"
import HeroScrollBackgroundImage from "components/Hero/HeroScrollBackgroundImage"

import HeroCaseDemo from "components/HeroCase/HeroCaseDemo"
import HeroCaseDemoWrapper from "components/HeroCase/HeroCaseDemoWrapper"
import HeroCaseDescription from "components/HeroCase/HeroCaseDescription"
import HeroCaseItem from "components/HeroCase/HeroCaseItem"
import HeroCaseItemLink from "components/HeroCase/HeroCaseItemLink"
import HeroCaseItemText from "components/HeroCase/HeroCaseItemText"
import HeroCaseItemTitle from "components/HeroCase/HeroCaseItemTitle"
import HeroCaseDemoBigMobile from "components/HeroCase/HeroCaseDemoBigMobile"

import HeroCaseDemoDesktop from "components/HeroCase/HeroCaseDemoDesktop"
import HeroCaseDemoMobile from "components/HeroCase/HeroCaseDemoMobile"
import HeroCaseInfo from "components/HeroCase/HeroCaseInfo"
import HeroCaseLinkClutch from "components/HeroCase/HeroCaseLinkClutch"
import HeroCaseItemContent from "components/HeroCase/HeroCaseItemContent"
import Image from "components/Image"
import htmlFormatting from "utils/htmlFormatting"
import MicromarkingWrapper from "components/MicromarkingWrapper"
import Meta from "components/Meta"
import HeroScrollContainer from "components/Hero/HeroScrollContainer"
import HeroScrollCaseTitle from "components/Hero/HeroScrollCaseTitle"
import HeroScrollDescription from "components/Hero/HeroScrollDescription"
import HeroScrollSectionWrapper from "components/Hero/HeroScrollSectionWrapper"
import HeroScrollCaseItem from "components/Hero/HeroScrollCaseItem"
import HeroScrollCaseItemContainer from "components/Hero/HeroScrollCaseItemContainer"
import HeroCaseImage from "components/Hero/HeroCaseImage"
import HeroScrollCaseItemLink from "components/Hero/HeroScrollCaseItemLink"
import HeroScrollItemText from "components/Hero/HeroScrollItemText"
import HeroScrollClutch from "components/Hero/HeroScrollClutch"
import HeroScrollClutchIcon from "components/Hero/HeroScrollClutchIcon"
import HeroScrollSectionContainer from "components/Hero/HeroScrollSectionContainer"
import HeroScrollBreadcrumbsLink from "components/Hero/HeroScrollBreadcrumbsLink"
import HeroScrollCaseContainerSmall from "components/Hero/HeroScrollCaseContainerSmall"
import HeroScrollCaseContainerBig from "components/Hero/HeroScrollCaseContainerBig"
import HeroScrollDemoContent from "components/Hero/HeroScrollDemoContent"
import Container from "components/Container"

const HeroCase = ({
  breadcrumbs,
  textBeforeTitle,
  textBeforeTitleTag,
  addQuotes,
  title,
  titleTag,
  heroText,
  backgroundImage,
  imageDesktop,
  imageMobile,
  type,
  units,
  clutchRating,
  clutchText,
  clutchLink,
  backgroundScrollHero,
}) => {
  if (backgroundScrollHero) {
    return (
      <HeroScrollSectionContainer>
        <HeroScrollSectionWrapper>
          <HeroScrollBackgroundImage {...backgroundScrollHero} />
          <HeroScrollContainer>
            {breadcrumbs?.length && (
              <Breadcrumbs itemsCope="" itemType="http://schema.org/BreadcrumbList">
                {breadcrumbs.map(
                  (el, idx) =>
                    (breadcrumbs.length - 1 !== idx && (
                      <li
                        itemProp="itemListElement"
                        itemsCope=""
                        itemType="https://schema.org/ListItem"
                      >
                        <HeroScrollBreadcrumbsLink
                          itemProp="item"
                          isActive={breadcrumbs.length - 1 === idx}
                          to={el.link}
                          key={el.id}
                        >
                          <span itemProp="name">{el.title}</span>
                          <Meta itemProp="position" content={idx + 1} />
                        </HeroScrollBreadcrumbsLink>
                      </li>
                    )) || (
                      <HeroScrollBreadcrumbsLink
                        key={el.id}
                        itemsCope=""
                        itemProp="itemListElement"
                        itemType="https://schema.org/ListItem"
                        isActive={breadcrumbs.length - 1 === idx}
                      >
                        <span itemProp="name">{el.title}</span>
                        <Meta itemProp="position" content={idx + 1} />
                      </HeroScrollBreadcrumbsLink>
                    ),
                )}
              </Breadcrumbs>
            )}
            <HeroScrollCaseTitle addQuotes={addQuotes} as={titleTag}>
              {(addQuotes ? "“‎‎" : "") + title + (addQuotes ? "”‎" : "")}
            </HeroScrollCaseTitle>
            {heroText && (
              <HeroScrollDescription
                itemprop="description"
                addQuotes={addQuotes}
                dangerouslySetInnerHTML={{
                  __html: htmlFormatting(heroText?.childMarkdownRemark?.html),
                }}
              />
            )}
          </HeroScrollContainer>
        </HeroScrollSectionWrapper>

        <HeroScrollCaseContainerSmall>
          <HeroScrollDemoContent
            type={type}
            imageDesktop={imageDesktop}
            imageMobile={imageMobile}
          />
        </HeroScrollCaseContainerSmall>
        <HeroScrollCaseItemContainer>
          {(units || [])
            .slice(0, clutchLink && clutchRating && clutchText ? 2 : 3)
            .map(({ id, title: itemTitle, values, caseIcon }) => (
              <HeroScrollCaseItem key={id}>
                <HeroCaseImage {...caseIcon} />
                <HeroCaseItemTitle>{itemTitle}</HeroCaseItemTitle>
                {values && (
                  <HeroCaseItemContent>
                    {values.map(({ id: valueId, title: valueTitle, link }) =>
                      link === null ? (
                        <React.Fragment key={valueId}>
                          <HeroScrollItemText>{valueTitle}</HeroScrollItemText>
                          {!isNaN(parseInt(valueTitle, 16)) && (
                            <Meta itemprop="dateCreated" content={valueTitle} />
                          )}
                        </React.Fragment>
                      ) : (
                        <HeroScrollCaseItemLink key={valueId} to={link}>
                          {valueTitle}
                          <Meta itemprop="keywords" content={valueTitle} />
                        </HeroScrollCaseItemLink>
                      ),
                    )}
                  </HeroCaseItemContent>
                )}
              </HeroScrollCaseItem>
            ))}
          {clutchLink && clutchRating && clutchText && (
            <HeroScrollCaseItem>
              <HeroScrollClutchIcon />
              <HeroCaseItemTitle> Clutch </HeroCaseItemTitle>
              <HeroCaseLinkClutch to={clutchLink}>
                <HeroScrollClutch text={clutchText || ""} rating={clutchRating} />
              </HeroCaseLinkClutch>
            </HeroScrollCaseItem>
          )}
        </HeroScrollCaseItemContainer>

        <HeroScrollCaseContainerBig>
          <HeroScrollDemoContent
            type={type}
            imageDesktop={imageDesktop}
            imageMobile={imageMobile}
          />
        </HeroScrollCaseContainerBig>
      </HeroScrollSectionContainer>
    )
  }

  return (
    <HeroSectionWrapper>
      <HeroWrapper backgroundImage={backgroundImage} addQuotes={addQuotes}>
        <HeroContainer>
          {breadcrumbs?.length && (
            <Breadcrumbs itemsCope="" itemType="http://schema.org/BreadcrumbList">
              {breadcrumbs.map(
                (el, idx) =>
                  (breadcrumbs.length - 1 !== idx && (
                    <li
                      itemProp="itemListElement"
                      itemsCope=""
                      itemType="https://schema.org/ListItem"
                    >
                      <HeroBreadcrumbsLink
                        itemProp="item"
                        isActive={breadcrumbs.length - 1 === idx}
                        to={el.link}
                        key={el.id}
                      >
                        <span itemProp="name">{el.title}</span>
                        <Meta itemProp="position" content={idx + 1} />
                      </HeroBreadcrumbsLink>
                    </li>
                  )) || (
                    <HeroBreadcrumbsLink
                      key={el.id}
                      itemsCope=""
                      itemProp="itemListElement"
                      itemType="https://schema.org/ListItem"
                      isActive={breadcrumbs.length - 1 === idx}
                    >
                      <span itemProp="name">{el.title}</span>
                      <Meta itemProp="position" content={idx + 1} />
                    </HeroBreadcrumbsLink>
                  ),
              )}
            </Breadcrumbs>
          )}
          {textBeforeTitle && (
            <HeroTextBeforeTitle as={textBeforeTitleTag}>
              {textBeforeTitle}1212121
            </HeroTextBeforeTitle>
          )}
          <MicromarkingWrapper itemscope="" itemtype="https://schema.org/CreativeWork">
            <Meta itemprop="name" content={title} />

            <HeroCaseTitle backgroundImage={backgroundImage} addQuotes={addQuotes} as={titleTag}>
              {(addQuotes ? "“‎‎" : "") + title + (addQuotes ? "”‎" : "")}
            </HeroCaseTitle>
            {heroText && (
              <HeroCaseText
                itemprop="description"
                backgroundImage={backgroundImage}
                addQuotes={addQuotes}
                dangerouslySetInnerHTML={{
                  __html: htmlFormatting(heroText?.childMarkdownRemark?.html),
                }}
              />
            )}
            <HeroImageContainer backgroundImage={backgroundImage} addQuotes={addQuotes}>
              {backgroundImage !== "None" && (
                <HeroBackgroundImage backgroundImage={backgroundImage} />
              )}
            </HeroImageContainer>

            <HeroCaseDemoWrapper>
              <HeroCaseDemo>
                {imageDesktop && (type === "Desktop" || type === "Desktop-mobile") && (
                  <HeroCaseDemoDesktop>
                    <Image itemprop="image" {...imageDesktop} />
                  </HeroCaseDemoDesktop>
                )}
                {imageMobile && type === "Desktop-mobile" && (
                  <HeroCaseDemoMobile>
                    <Image {...imageMobile} />
                  </HeroCaseDemoMobile>
                )}
                {imageMobile && imageDesktop && type === "Mobile-mobile" && (
                  <>
                    <HeroCaseDemoBigMobile>
                      <Image {...imageDesktop} objectFit="cover" />
                    </HeroCaseDemoBigMobile>
                    <HeroCaseDemoBigMobile>
                      <Image {...imageMobile} objectFit="cover" />
                    </HeroCaseDemoBigMobile>
                  </>
                )}
                {imageMobile && type === "Mobile" && (
                  <HeroCaseDemoBigMobile>
                    <Image {...imageMobile} objectFit="cover" />
                  </HeroCaseDemoBigMobile>
                )}
              </HeroCaseDemo>
            </HeroCaseDemoWrapper>
            <HeroCaseDescription>
              {units?.map(({ id, title: itemTitle, values }) => (
                <HeroCaseItem key={id}>
                  <HeroCaseItemTitle>{itemTitle}</HeroCaseItemTitle>

                  {values && (
                    <HeroCaseItemContent>
                      {values.map(({ id: valueId, title: valueTitle, link }) =>
                        link === null ? (
                          <>
                            <HeroCaseItemText key={valueId}>{valueTitle}</HeroCaseItemText>
                            {!isNaN(parseInt(valueTitle, 16)) && (
                              <Meta itemprop="dateCreated" content={valueTitle} />
                            )}
                          </>
                        ) : (
                          <HeroCaseItemLink key={valueId} to={link}>
                            {valueTitle}
                            <Meta itemprop="keywords" content={valueTitle} />
                          </HeroCaseItemLink>
                        ),
                      )}
                    </HeroCaseItemContent>
                  )}
                </HeroCaseItem>
              ))}

              <HeroCaseItem>
                {clutchLink && clutchRating && clutchText && (
                  <>
                    <HeroCaseItemTitle> Clutch </HeroCaseItemTitle>
                    <HeroCaseLinkClutch to={clutchLink}>
                      <HeroCaseInfo text={clutchText || ""} rating={clutchRating} />
                    </HeroCaseLinkClutch>
                  </>
                )}
              </HeroCaseItem>
            </HeroCaseDescription>
          </MicromarkingWrapper>
        </HeroContainer>
      </HeroWrapper>
    </HeroSectionWrapper>
  )
}

HeroCase.propTypes = {
  breadcrumbs: PropTypes.arrayOf(
    PropTypes.exact({
      id: PropTypes.string,
      title: PropTypes.string.isRequired,
      link: PropTypes.string.isRequired,
    }),
  ).isRequired,
  textBeforeTitle: PropTypes.string.isRequired,
  textBeforeTitleTag: PropTypes.string.isRequired,
  type: PropTypes.string.isRequired,
  addQuotes: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  titleTag: PropTypes.string.isRequired,
  heroText: PropTypes.string.isRequired,
  backgroundImage: PropTypes.string.isRequired,
  imageDesktop: PropTypes.string.isRequired,
  imageMobile: PropTypes.string.isRequired,
  units: PropTypes.arrayOf(
    PropTypes.exact({
      id: PropTypes.string.isRequired,
      title: PropTypes.string.isRequired,
      values: PropTypes.arrayOf(
        PropTypes.exact({
          id: PropTypes.string.isRequired,
          title: PropTypes.string.isRequired,
          link: PropTypes.string.isRequired,
        }),
      ).isRequired,
    }),
  ).isRequired,
  clutchRating: PropTypes.string.isRequired,
  clutchText: PropTypes.string.isRequired,
  clutchLink: PropTypes.string.isRequired,
  backgroundScrollHero: PropTypes.string.isRequired,
}

export default HeroCase
